import { Base64 } from 'js-base64';
import { buildRendererQueryString } from './rendererQueryString.js';
export function pickRendererUrl(rendererUrl, mode) {
    return rendererUrl && typeof rendererUrl === 'object'
        ? rendererUrl[mode]
        : (rendererUrl ?? null);
}
export function createRendererUrl(rendererUrl, fixtureId, locked) {
    if (hasFixtureVar(rendererUrl)) {
        if (!fixtureId)
            return replaceFixtureVar(rendererUrl, 'index');
        return (replaceFixtureVar(rendererUrl, encodeRendererUrlFixture(fixtureId)) +
            buildRendererQueryString({ locked }));
    }
    else {
        if (!fixtureId)
            return rendererUrl;
        const baseUrl = hostOnlyUrl(rendererUrl) ? rendererUrl + '/' : rendererUrl;
        return baseUrl + buildRendererQueryString({ fixtureId, locked });
    }
}
export function createWebRendererUrl(rendererUrl, fixtureId, locked) {
    return applyWindowHostnameToRendererUrl(createRendererUrl(rendererUrl, fixtureId, locked));
}
export function encodeRendererUrlFixture(fixtureId) {
    return Base64.encode(JSON.stringify(fixtureId));
}
export function decodeRendererUrlFixture(fixture) {
    return JSON.parse(Base64.decode(fixture));
}
function hasFixtureVar(rendererUrl) {
    return rendererUrl.includes('<fixture>');
}
function replaceFixtureVar(rendererUrl, fixture) {
    return rendererUrl.replace(/<fixture>/g, fixture);
}
function hostOnlyUrl(url) {
    try {
        const { protocol, pathname } = new URL(url);
        return (protocol === 'http:' || protocol === 'https:') && pathname === '/';
    }
    catch (err) {
        return false;
    }
}
function applyWindowHostnameToRendererUrl(rendererUrl) {
    try {
        const url = new URL(rendererUrl);
        const windowHostname = window.location.hostname;
        if (url.hostname !== windowHostname && url.hostname === 'localhost')
            url.hostname = windowHostname;
        return url.toString();
    }
    catch {
        return rendererUrl;
    }
}
